import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/es'
import 'element-ui/lib/theme-chalk/index.css'
import '../sass/_element-variables.scss'

import App from '~/components/App'


import '~/plugins'
import '~/components'


Vue.use(ElementUI, { locale });

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})




// WEBPACK FOOTER //
// ./resources/assets/js/app.js